export const TAG_VERSION = process.env.NEXT_PUBLIC_TAG_VERSION

export const REMOTE_API_BASE_URL = process.env.REMOTE_API_BASE_URL
export const PUBLIC_DOMAIN_URL = process.env.NEXT_PUBLIC_DOMAIN_URL

export const PUBLIC_NAUTILUS_CLIENT_API_URL = process.env.NEXT_PUBLIC_NAUTILUS_CLIENT_API_URL
export const PUBLIC_PAM_CLIENT_API_URL = process.env.NEXT_PUBLIC_PAM_CLIENT_API_URL
export const PUBLIC_SQUIDWARD_CLIENT_API_URL = process.env.NEXT_PUBLIC_SQUIDWARD_CLIENT_API_URL
export const PUBLIC_CHAMELEON_CLIENT_API_URL = process.env.NEXT_PUBLIC_CHAMELEON_CLIENT_API_URL
export const PUBLIC_CHAMELEON_V2_CLIENT_API_URL = process.env.NEXT_PUBLIC_CHAMELEON_V2_CLIENT_API_URL

export const PUBLIC_NARCO_CLIENT_API_URL = process.env.NEXT_PUBLIC_NARCO_CLIENT_API_URL
export const PUBLIC_NEO_CLIENT_API_URL = process.env.NEXT_PUBLIC_NEO_CLIENT_API_URL
export const PUBLIC_SCR_CLIENT_API_URL = process.env.NEXT_PUBLIC_SCR_CLIENT_API_URL
export const PUBLIC_CDN_URL = process.env.NEXT_PUBLIC_CDN_URL

export const BINOBAN_SOURCE_IDENTIFIER = process.env.BINOBAN_SOURCE_IDENTIFIER
export const BINOBAN_API_KEY = process.env.BINOBAN_API_KEY
export const BINOBAN_SPECIFIC_URL = process.env.BINOBAN_SPECIFIC_URL

export const DWIGHT_BASE_URL = process.env.NEXT_DWIGHT_BASE_URL
